<template>
  <div class="hundred_percent_form left_form">
    <el-form :label-position="labelPosition" v-loading="loading" :rules="formRules" ref="dataForm" :model="form" label-width="100px">
        <el-form-item label="1美元 =" prop="ratetype">
          <el-input style="width: 160px;" v-model="form.ratetype" clearable ><template slot="append">元</template></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="formSubmit()" :loading="formLoading">保 存</el-button>
        <el-button @click="onCancel">取 消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getInfo, edit } from "../../api/setting/comRate.js";
export default {
    data() {
        let checkType = (rule, value, callback) => {
            if (
                !/^(([1-9][0-9]*)|(([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2})))$/.test(
                    value
                ) &&
                value != null &&
                value != ""
            ) {
                callback(new Error("请输入正确金额"));
            } else {
                callback();
            }
        };
        return {
            loading: true,
            formLoading: false,
            divLoading: false,
            form: {
                ratetype: "",
                rateid:""
            },
            labelPosition: "left",
            formRules: {
                ratetype: [{ validator: checkType, trigger: "blur" }]
            }
        };
    },
    methods: {
        onCancel() {
            this.getInfo();
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        },
        getInfo() {
            this.loading = true;
            getInfo(this.query).then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    if (response.data) {
                        this.form = response.data;
                    }
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                })
                .catch(() => {});
        },
        formSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid){
                    this.formLoading = true;
                    let data = Object.assign({}, this.form);
                    console.log(data);
                    edit(data).then(response => {
                        this.formLoading = false;
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("操作成功");
                        //刷新表单
                        this.getInfo();
                        // 清空验证信息表单
                        if (this.$refs["dataForm"]) {
                            this.$refs["dataForm"].clearValidate();
                        }
                    })
                }
            });
        }
    },
    created() {
        // 加载版本数据
        this.getInfo();
    }
};
</script>

<style type="text/scss" lang="scss">
body {
    margin: 0;
}
.app_logo {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.loading_div {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
</style>
